<template>
  <v-container grid-list-xs fluid>
    <v-row row wrap justify="center">
      <v-col v-if="loadingFolders" class="standard col-12">
        <Loader text=""></Loader>
      </v-col>
      <v-col
        v-if="
          !loadingFolders && (!availableFolders || !availableFolders.length)
        "
        class="col-10"
      >
        No linkable folders found. Only top level folders that you own (not
        shared with you) can have a sub folder linked to it.
      </v-col>
      <v-col
        v-if="!loadingFolders && availableFolders && availableFolders.length"
        class="col-6"
      >
        <v-autocomplete
          v-model="selected"
          :items="availableFolders"
          :filter="customFilter"
          :error-messages="showError"
          small-chips
          multiple
          deletable-chips
          clearable
          item-text="name"
          item-value="id"
          label="Select folders to link to"
          @change="toggleFolderSelection"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashSortBy from "lodash/sortBy";
import lodashFindLastIndex from "lodash/findLastIndex";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_COLLABORATION } from "@/store";

const EMITTED_ACTIONS = {
  INPUT: "input",
};

export default {
  name: "CollaborationFolderList",
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    folder: {
      type: Object,
      required: true,
    },
    init: {
      type: String,
    },
  },
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  async mounted() {
    this.loadFolders();
  },
  data() {
    return {
      selected: [],
      availableFolders: [],
      loadingFolders: true,
    };
  },
  computed: {
    ...mapGetters({
      folders: MODULE_PREFIX_COLLABORATION + "folders",
    }),
    showError() {
      if (this.selected.length > 0) {
        return null;
      }
      return "At least one folder must be selected";
    },
  },
  methods: {
    async loadFolders() {
      this.loadingFolders = true;
      const SORTED = lodashSortBy(this.folders, "name");
      let mapped = [];
      SORTED.forEach((folder) => {
        if (
          folder.id !== this.folder.parent &&
          this.value.indexOf(folder.id) < 0 &&
          folder.isOwner
        ) {
          mapped.push({
            id: folder.id,
            name: folder.name,
            selected: this.selected.indexOf(folder.id) > -1,
          });
        }
      });
      this.availableFolders = mapped;
      this.loadingFolders = false;
    },
    customFilter(item, queryText, itemText) {
      const SEARCH = queryText.toLowerCase();
      const TEXT = item.name.toLowerCase();
      return TEXT.indexOf(SEARCH) > -1;
    },
    addFolder(id) {
      this.selected.push(id);
    },
    removeFolder(id) {
      const index = lodashFindLastIndex(this.selected, id);
      this.selected.splice(index, 1);
    },
    toggleFolderSelection(folder) {
      this.$emit(EMITTED_ACTIONS.INPUT, this.selected);
    },
  },
  watch: {
    init: {
      handler() {
        if (this.init) {
          this.loadFolders();
          this.selected = [];
        }
      },
    },
    folders: {
      handler() {
        if (this.folders) {
          this.loadFolders();
        }
      },
    },
  },
  beforeDestroy() {
    this.selected = [];
  },
};
</script>

<style scoped>
.loading {
  text-align: center;
  padding-top: 25px;
}
.select-btn {
  font-size: 11px;
  padding-left: 25px !important;
  margin: 5px 0;
  width: 95%;
}
.list-selected {
  position: absolute;
  left: -21px;
  font-size: 15px;
  color: #2196f3 !important;
}
.standard {
  font-size: 24px;
}
</style>
